import { connect } from 'react-redux'
import { getHome } from '../selectors'
import { setClient } from '../../selection/actions'
import {
  getNodeProgressById,
  getNodeSiblingsById,
  getSelectionByKey,
} from '../../selection/selectors'
import BottomNav from '../components/bottomNav'

const getCurrentStep = ({ currentPath, steps }) => {
  steps.find(step => step.config.path === currentPath[0])
}

const getCurrentRootId = ({ currentPath, steps }) => {
  if (currentPath.length > 1) {
    return currentPath[1]
  }
  const currentStep = getCurrentStep({
    currentPath,
    steps,
  })

  if (currentStep !== undefined && 'rootNode' in currentStep) {
    return currentStep.rootNode.id
  }
  return false
}

const getGoBack = ({ history }) => history.length > 1 && history.goBack

const getNext = ({ currentPath, steps, incomplete }) => {
  const currentIndex = steps.findIndex(
    step => step.config.path === currentPath[0],
  )
  if (
    currentIndex > -1 &&
    currentIndex < incomplete &&
    incomplete < steps.length
  ) {
    return {
      button: 'weiter',
      path: steps[incomplete].config.path,
    }
  }
  if (currentIndex === steps.length - 1) {
    return {
      button: 'Konfiguration überarbeiten?',
      finished: true,
      path: steps[0].config.path,
    }
  }
  return false
}

const getProgress = ({ state, ownProps }) => {
  const { currentPath, steps } = ownProps

  const currentStep = steps.find(
    step => step.config.path === currentPath.join('/'),
  )
  if (currentStep !== undefined && 'rootNode' in currentStep) {
    return getNodeProgressById({
      state,
      id: currentStep.rootNode.id,
    })
  }
  return false
}

const mapStateToProps = (state, ownProps) => ({
  budget: getSelectionByKey({
    state,
    key: 'budget',
  }),
  currentStep: getCurrentStep(ownProps),
  goBack: getGoBack(ownProps),
  home: getHome(state),
  siblings: getNodeSiblingsById({
    state,
    id: getCurrentRootId(ownProps),
  }),
  next: getNext(ownProps),
  progress: getProgress({
    state,
    ownProps,
  }),
})

const mapDispatchToProps = dispatch => ({
  reconfigure: () => dispatch(setClient({})),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BottomNav)



// WEBPACK FOOTER //
// ./src/modules/core/containers/bottomNav.js